import React from 'react';
import { NumberInput } from '@mantine/core';
import { cssLengthToPx, pxToRemCss } from '../../utils/proposalUnits';
import { useDebouncedFieldValue } from './useDebouncedFieldValue';

/**
 * Champ espacement en px (affichage) ↔ rem (stockage CSS).
 * Les commerciaux pensent en px ; « 0.813rem » est du jargon. La valeur
 * stockée reste une longueur CSS rem (responsive, viewer inchangé).
 * Frappe en état local, store Puck écrit à la pause (400 ms) / au blur —
 * un dispatch par frappe re-rend le canvas (lag grandes pages).
 */
/** Plafond par défaut : un espacement. Les hauteurs de bloc passent `max`. */
const DEFAULT_MAX_PX = 400;

export function PxSpacingInput({
  value, onChange, label, placeholder, description, max = DEFAULT_MAX_PX,
}) {
  const commit = (v) => {
    if (v === '' || v == null) {
      onChange('');
      return;
    }
    onChange(pxToRemCss(v));
  };

  const {
    local, change, focus, endFocus,
  } = useDebouncedFieldValue(value, commit, { toLocal: (v) => cssLengthToPx(v) ?? '' });

  return (
    <NumberInput
      size="xs"
      label={label}
      placeholder={placeholder}
      description={description}
      value={local}
      onFocus={focus}
      onBlur={() => {
        endFocus();
        commit(local);
      }}
      onChange={change}
      min={0}
      max={max}
      step={1}
      suffix=" px"
      clampBehavior="strict"
      allowDecimal={false}
    />
  );
}

export function puckPxSpacingField(label, description, { max } = {}) {
  return {
    type: 'custom',
    label,
    render: ({ value, onChange }) => (
      <PxSpacingInput
        value={value}
        onChange={onChange}
        label={label}
        description={description}
        max={max}
      />
    ),
  };
}
